import { LogistikanbieterEnum } from "../ajax/types/LogistikanbieterEnum";
import { IJSLVNode } from "jsl-render";

export function GenerateTrackingUrl(packageNo: string, anbieter: LogistikanbieterEnum): IJSLVNode {
    if (anbieter === LogistikanbieterEnum.DHL) {
        return <div class="tracking">
            <span>Tracking: </span>
            <a href={"https://www.dhl.de/de/privatkunden/dhl-sendungsverfolgung.html?piececode=" + packageNo} target="_blank">{packageNo}</a>
        </div>;
    } else if (anbieter === LogistikanbieterEnum.DPD) {
        return <div class="tracking">
            <span>Tracking: </span>
            <a href={"https://my.dpd.de/myParcel.aspx?parcelno=" + packageNo} target="_blank">{packageNo}</a>
        </div>;
    }
    return <div class="tracking">{packageNo}</div>;
}
